import { Mic, MicOff, Square, Lightbulb, Loader2 } from "lucide-react";
import { RichText } from "@/components/RichText";
import { MicTestButton } from "@/components/MicTest";

export const HintBox = ({ points, level }) =>
  level > 0 && (
    <div data-testid="viva-hint-box" className="mt-4 rounded-xl p-4 text-sm space-y-2" style={{ background: "color-mix(in srgb, var(--warn) 10%, transparent)", border: "1px dashed var(--warn)" }}>
      {points.slice(0, level).map((p, i) => (
        <p key={i}>
          <Lightbulb size={14} className="inline mr-1.5 -mt-0.5" style={{ color: "var(--warn)" }} />
          <strong className="font-semibold">{p.label || "Key point"}</strong>
          {p.label && p.text ? " — " : ""}
          <RichText text={p.text.length > 160 ? p.text.slice(0, 160) + "…" : p.text} />
        </p>
      ))}
    </div>
  );

export const AnswerPanel = ({ index, recording, pending, transcript, onToggleRecord, onChange, disabled, level = 0, silent = false }) => (
  <div className="mt-6">
    <div className="flex flex-wrap items-center gap-4">
      <button
        data-testid="viva-record-mic-button"
        onClick={onToggleRecord}
        disabled={disabled}
        className={`h-14 w-14 rounded-full grid place-items-center text-white transition-transform hover:scale-105 disabled:opacity-40 ${recording ? "recording-pulse" : ""}`}
        style={{ background: recording ? "var(--alert)" : "var(--brand)" }}
        aria-label={recording ? "Stop recording" : "Start recording"}
      >
        {recording ? <Square size={18} fill="currentColor" /> : <Mic size={22} />}
      </button>
      <div className="text-sm flex-1 min-w-[12rem]" data-testid="viva-record-status" style={{ color: "var(--ink-2)" }}>
        {recording ? <span style={{ color: "var(--alert)" }} className="font-medium">Recording… speak your answer, tap to stop</span>
          : pending ? <span className="flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Transcribing…</span>
          : "Tap the mic and answer out loud (or type below)"}
        {recording && (
          <span className="mt-2 block h-2 rounded-full overflow-hidden max-w-xs" style={{ background: "var(--muted-bg)" }}>
            <span data-testid="viva-record-level" className="block h-full rounded-full transition-[width] duration-100" style={{ width: `${Math.round(level * 100)}%`, background: "var(--ok)" }} />
          </span>
        )}
      </div>
      <MicTestButton className="h-9 px-3" testid="viva-mic-test-button" />
    </div>
    {recording && silent && (
      <p data-testid="viva-record-silent-warning" className="mt-3 rounded-lg px-3 py-2 text-sm flex gap-2" style={{ background: "color-mix(in srgb, var(--alert) 10%, transparent)", color: "var(--alert)" }}>
        <MicOff size={16} className="shrink-0 mt-0.5" /> We can't hear anything from your microphone. It may be muted or the wrong device is selected. Use Test microphone to check.
      </p>
    )}
    <textarea
      data-testid={`viva-transcript-input-${index}`}
      value={transcript}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Your transcribed answer appears here. You can edit or type."
      rows={4}
      className="mt-4 w-full rounded-xl p-3 text-sm resize-y outline-none focus:ring-2 focus:ring-[var(--accent)]"
      style={{ background: "var(--muted-bg)", border: "1px solid var(--line)", color: "var(--ink)" }}
    />
  </div>
);
